/**
 * Wrapper for auth0-js
 * 
 * Exposes the relevant methods needed for authentication and makes sure promises 
 * are returned.
 */
let auth0Service = auth0ClientFactory => {
  return {
    checkSession: () => {
      return auth0ClientFactory.build()
        .then(auth0 => {
          return new Promise((resolve, reject) => {
            auth0.checkSession({}, (error, result) => {
              return error ? reject(error) : resolve(result);
            });
          });
        }); 
    },
    authorize: () => auth0ClientFactory.build()
      .then(auth0 => auth0.authorize()),
    logout: () => auth0ClientFactory.build()
      .then(auth0 => auth0.logout()),
    changePassword: email => {
      const options = {
        connection: 'Username-Password-Authentication',
        email: email
      };

      return auth0ClientFactory.build()
        .then(auth0 => {
          return new Promise((resolve, reject) => {
            return auth0.changePassword(options, (error, result) => {
              return error ? reject(error) : resolve(result);
            });
          });
        });
    },
    parseHash: options => {
      return auth0ClientFactory.build()
        .then(auth0 => {
          return new Promise((resolve, reject) => {
            auth0.parseHash(options, (error, result) => {
              return error ? reject(error) : resolve(result);
            });
          });
        });
    }
  };
};

auth0Service.$inject = [ 'auth0ClientFactory' ];

export default auth0Service;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/auth0.service.js